<div class="payment-card-wrapper">
  <div class="payment-card">
    <div class="payment-card__description-container">
      <span class="label" [innerHTML]="paymentHeaderDescription" [ngClass]="{ 'pb-0': isPaymentPending }"></span>
      <span class="label label-gray" [innerHTML]="paymentSubHeaderDescription"></span>
    </div>
    <div class="payment-card__action-container" *ngIf="!isPaymentPending">
      <div class="row payment-card__action">
        <div class="col-12 col-xl-4 payment-card__action-totals">
          <span class="label">
            {{ (shipment.paymentState === enumPaymentState.SUCCESS ? "LABELS.ADDITIONAL_CHARGES" : "LABELS.TOTAL_PAYMENT") | translate }}:
          </span>
          <span class="value">{{ totalPrice | currency : "USD" : "symbol" : "1.2-2" }}</span>
        </div>
        <div class="col-12 col-xl-8 mt-3 mt-xl-0 pl-xl-0 payment-card__action-button">
          <payment-button [referenceNumber]="shipment.referenceNumber"></payment-button>
        </div>
      </div>
    </div>
  </div>
</div>
